import { useCaseFactMutations, useCaseFacts } from '@/modules/projects/hooks'
import { cn } from '@/utils'
import { CaseFactEditor } from './CaseFactEditor'
import { CaseFactRow } from './CaseFactRow'

const SCROLL_AREA =
  'overflow-y-auto scrollbar-thin scrollbar-thumb-neutral-300 hover:scrollbar-thumb-neutral-400 scrollbar-track-transparent'

interface CaseFactListProps {
  slug: string
  isAdding: boolean
  onAddingDone: () => void
  // Classes for the scroll area, e.g. a `max-h-*` cap. Past it the list scrolls inside itself.
  scrollClassName?: string
}

export const CaseFactList = ({
  slug,
  isAdding,
  onAddingDone,
  scrollClassName,
}: CaseFactListProps) => {
  const facts = useCaseFacts()
  const { addCaseFact } = useCaseFactMutations()
  // The server sends oldest first. Newest first puts a new fact right where it was typed.
  const newestFirst = [...facts].reverse()

  return (
    <>
      {facts.length === 0 && !isAdding && (
        <p className="text-sm text-muted-foreground">
          No facts yet. Add what Daystrom AI should always know about this case.
        </p>
      )}
      {(facts.length > 0 || isAdding) && (
        <div className={cn(SCROLL_AREA, scrollClassName)}>
          <ul className="divide-y">
            {isAdding && (
              <li className="py-2 last:pb-0">
                <CaseFactEditor
                  onSubmit={(body) =>
                    addCaseFact(slug, body).then(onAddingDone)
                  }
                  onCancel={onAddingDone}
                />
              </li>
            )}
            {newestFirst.map((fact) => (
              <CaseFactRow key={fact.id} slug={slug} fact={fact} />
            ))}
          </ul>
        </div>
      )}
    </>
  )
}
